<script setup lang="ts">
  import DialogActionButton from '@/components/dialog/DialogActionButton.vue'
  import { SpeckleModelSelect, SpeckleProjectSearch } from '@haskoning/vue-speckle'
  import { SpeckleMode, useSpeckleManagement } from '@/composables/useSpeckleManagement'
  import { storeToRefs } from 'pinia'
  import { useSectionLineUploadCollectionsStore } from '@/stores/sectionLineUploadCollections'
  import GenericDialog from '@/components/dialog/GenericDialog.vue'
  import SpeckleLoginNoticeDialog from '@/components/dialog/SpeckleLoginNoticeDialog.vue'
  import TextField from '@/components/form/TextField.vue'

  const sectionLineUploadCollectionStore = useSectionLineUploadCollectionsStore()
  const { exportSectionLineToSpeckleDialog } = storeToRefs(sectionLineUploadCollectionStore)
  const speckleManagement = useSpeckleManagement(SpeckleMode.EXPORT_SECTION_LINE)
  const { canUseSpeckle, speckleCommitMessage, canExportSectionLine, exportingSectionLines } =
    speckleManagement

  async function exportSectionLinesToSpeckle() {
    await speckleManagement.exportSectionLinesToSpeckle()
    sectionLineUploadCollectionStore.toggleExportSectionLineToSpeckleDialog(false)
  }
</script>

<template>
  <GenericDialog
    v-if="canUseSpeckle"
    v-model="exportSectionLineToSpeckleDialog"
    @clicked-outside="sectionLineUploadCollectionStore.toggleExportSectionLineToSpeckleDialog"
  >
    <template #title>Send Section Lines to Speckle</template>
    <template #default>
      <SpeckleProjectSearch :initialization-function="() => {}"></SpeckleProjectSearch>
      <SpeckleModelSelect variant="filled" class="mt-2"></SpeckleModelSelect>
      <TextField
        v-model="speckleCommitMessage"
        label="Commit Message"
        :rules="[(v: string) => !!v || 'Commit message is required']"
        class="mt-2"
      ></TextField>
    </template>
    <template #actions>
      <DialogActionButton
        @click="sectionLineUploadCollectionStore.toggleExportSectionLineToSpeckleDialog"
      >
        Cancel
      </DialogActionButton>
      <DialogActionButton
        :disabled="!canExportSectionLine"
        @click="exportSectionLinesToSpeckle"
        :loading="exportingSectionLines"
      >
        Send
      </DialogActionButton>
    </template>
  </GenericDialog>
  <SpeckleLoginNoticeDialog v-else v-model="exportSectionLineToSpeckleDialog">
  </SpeckleLoginNoticeDialog>
</template>

<style scoped></style>
